module.exports = __webpack_public_path__ + "static/media/BunVenit2.00ac1428.jpeg";